import styled from 'styled-components';

export const Glyph = styled.span`
  display: inline-flex;
  line-height: 0;
`;
